import React from 'react';
import ReactDOM from 'react-dom';
import ModalAlert from './components/modal_alert';

const show_alert = props => {
    let component = null;
    const lastEle = document.getElementById('alertModal');

    if (lastEle) {
        lastEle.parentElement.removeChild(lastEle); // 删除上一次的弹窗
    }
    const div = document.createElement('div');

    div.setAttribute('id', 'alertModal');
    document.body.appendChild(div);

    const onClose = () => {
        if (div) {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentElement) div.parentElement.removeChild(div);
        }

        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    };

    ReactDOM.render(
        /* eslint-disable */
        <ModalAlert {...props} onClose={onClose} ref={c => (component = c)} isOpen>
            {props.content}
        </ModalAlert>,
        /* eslint-enable */
        div,
    );

    // console.dir(component);

    // return () => component.close();
};

const Alert = {};

Alert.success = props =>
    show_alert({
        ...props,
        type: 'success',
    });
Alert.warning = props =>
    show_alert({
        ...props,
        type: 'warning',
    });

Alert.default = props =>
    show_alert({
        ...props,
        type: 'default',
    });

export default Alert;
